import React from 'react'
import { useLanguage } from '../contexts/LanguageContext';
import { contentData } from '../data/contentData';

const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.app.audio_sum';

function HeroSection() {
    const { language } = useLanguage();
    const content = contentData[language].hero;

    return (
        <section className="redesign-hero" style={{
            padding: '160px 24px 100px',
            textAlign: 'center',
            position: 'relative',
            overflow: 'hidden',
            background: '#FFFFFF'
        }}>
            {/* Subtle gradient blobs */}
            <div style={{
                position: 'absolute',
                top: '-50%',
                left: '-20%',
                width: '140%',
                height: '100%',
                background: 'radial-gradient(ellipse at 30% 0%, rgba(108, 58, 237, 0.06) 0%, transparent 60%), radial-gradient(ellipse at 70% 0%, rgba(14, 165, 233, 0.05) 0%, transparent 60%)',
                pointerEvents: 'none'
            }} />
            {/* Bottom border line */}
            <div style={{
                position: 'absolute',
                bottom: 0,
                left: '50%',
                transform: 'translateX(-50%)',
                width: '60%',
                height: '1px',
                background: 'linear-gradient(90deg, transparent, #E2E8F0, transparent)'
            }} />

            <div style={{ position: 'relative', zIndex: 1, maxWidth: '860px', margin: '0 auto' }}>
                {/* Badge */}
                <div style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '8px',
                    background: 'linear-gradient(135deg, #EDE9FE, #E0F2FE)',
                    color: '#6C3AED',
                    padding: '6px 18px',
                    borderRadius: '9999px',
                    fontSize: '13px',
                    fontWeight: '600',
                    marginBottom: '32px',
                    border: '1px solid rgba(108, 58, 237, 0.1)',
                    fontFamily: '"Inter", sans-serif'
                }} data-aos="fade-down">
                    <i className="fas fa-sparkles" style={{ fontSize: '12px' }}></i>
                    {language === 'ar' ? 'معالجة الصوت والفيديو بالذكاء الاصطناعي' : 'AI-Powered Audio & Video Processing'}
                </div>

                {/* Title */}
                <h1 style={{
                    fontFamily: '"Playfair Display", serif',
                    fontSize: 'clamp(36px, 5vw, 62px)',
                    fontWeight: '700',
                    lineHeight: '1.15',
                    color: '#0F172A',
                    marginBottom: '24px',
                    letterSpacing: '-0.02em'
                }} data-aos="fade-up">
                    {language === 'ar'
                        ? <>لخص | تلخيص <span style={{
                            background: 'linear-gradient(135deg, #6C3AED, #0EA5E9)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                            backgroundClip: 'text'
                        }}>صوتي بالذكاء الاصطناعي</span> ونسخ الفيديو</>
                        : <>Audiosum | AI-Powered <span style={{
                            background: 'linear-gradient(135deg, #6C3AED, #0EA5E9)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                            backgroundClip: 'text'
                        }}>Audio Summary</span> &amp; Video Transcription</>
                    }
                </h1>

                {/* Description */}
                <p style={{
                    fontSize: '18px',
                    lineHeight: '1.8',
                    color: '#475569',
                    maxWidth: '680px',
                    margin: '0 auto 36px',
                    fontFamily: '"Inter", sans-serif'
                }} data-aos="fade-up" data-aos-delay="100"
                   dangerouslySetInnerHTML={{ __html: content.description }}
                />

                {/* Tags */}
                <div style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'center',
                    gap: '10px',
                    marginBottom: '40px'
                }} data-aos="fade-up" data-aos-delay="200">
                    {content.badges.map((badge, index) => (
                        <span
                            key={index}
                            style={{
                                padding: '8px 18px',
                                background: '#F8FAFC',
                                border: '1px solid #E2E8F0',
                                borderRadius: '9999px',
                                fontSize: '13px',
                                fontWeight: '500',
                                color: '#475569',
                                transition: 'all 0.3s ease',
                                cursor: 'default',
                                fontFamily: '"Inter", sans-serif'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.borderColor = '#8B5CF6';
                                e.currentTarget.style.color = '#6C3AED';
                                e.currentTarget.style.background = 'rgba(108, 58, 237, 0.04)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.borderColor = '#E2E8F0';
                                e.currentTarget.style.color = '#475569';
                                e.currentTarget.style.background = '#F8FAFC';
                            }}
                        >
                            {badge}
                        </span>
                    ))}
                </div>

                {/* CTA Buttons */}
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '16px',
                    marginBottom: '48px',
                    flexWrap: 'wrap'
                }} data-aos="fade-up" data-aos-delay="300">
                    <a
                        href={`https://audiosum.app/signup?lang=${language}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '8px',
                            padding: '14px 36px',
                            background: 'linear-gradient(135deg, #6C3AED, #0EA5E9)',
                            color: 'white',
                            borderRadius: '9999px',
                            fontSize: '16px',
                            fontWeight: '600',
                            textDecoration: 'none',
                            border: 'none',
                            boxShadow: '0 4px 15px rgba(108, 58, 237, 0.3)',
                            transition: 'all 0.3s ease',
                            fontFamily: '"Inter", sans-serif'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'translateY(-2px)';
                            e.currentTarget.style.boxShadow = '0 8px 25px rgba(108, 58, 237, 0.4)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = '0 4px 15px rgba(108, 58, 237, 0.3)';
                        }}
                    >
                        {content.ctaButton} <i className="fas fa-arrow-right" style={{ fontSize: '14px' }}></i>
                    </a>
                    <a
                        href="#how-it-works"
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '8px',
                            padding: '14px 36px',
                            background: '#F8FAFC',
                            color: '#0F172A',
                            borderRadius: '9999px',
                            fontSize: '16px',
                            fontWeight: '600',
                            textDecoration: 'none',
                            border: '1px solid #E2E8F0',
                            transition: 'all 0.3s ease',
                            fontFamily: '"Inter", sans-serif'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.background = '#F1F5F9';
                            e.currentTarget.style.borderColor = '#CBD5E1';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.background = '#F8FAFC';
                            e.currentTarget.style.borderColor = '#E2E8F0';
                        }}
                    >
                        {content.demoButton}
                    </a>
                </div>

                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '12px',
                    marginBottom: '48px'
                }} data-aos="fade-up" data-aos-delay="350">
                    <p style={{
                        margin: 0,
                        fontSize: '14px',
                        fontWeight: '600',
                        color: '#475569',
                        fontFamily: '"Inter", sans-serif'
                    }}>
                        {language === 'ar' ? 'متوفر أيضاً على Android' : 'Also available on Android'}
                    </p>
                    <a
                        href={GOOGLE_PLAY_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={language === 'ar' ? 'حمّل تطبيق Audiosum من Google Play' : 'Get the Audiosum app on Google Play'}
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            transition: 'transform 0.3s ease, opacity 0.3s ease'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'translateY(-2px)';
                            e.currentTarget.style.opacity = '0.92';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.opacity = '1';
                        }}
                    >
                        <img
                            src="/imgs/google-play-badge.png"
                            alt={language === 'ar' ? 'احصل عليه من Google Play' : 'Get it on Google Play'}
                            style={{ display: 'block', height: '48px', width: 'auto', borderRadius: '6px' }}
                        />
                    </a>
                </div>

                {/* Social Proof */}
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '24px',
                    color: '#94A3B8',
                    fontSize: '14px',
                    fontFamily: '"Inter", sans-serif',
                    flexWrap: 'wrap'
                }} data-aos="fade-up" data-aos-delay="400">
                    <div style={{ display: 'flex' }}>
                        {['J', 'S', 'M', 'A'].map((letter, i) => (
                            <div key={i} style={{
                                width: '32px', height: '32px', borderRadius: '50%',
                                border: '2px solid white',
                                marginLeft: i === 0 ? 0 : '-8px',
                                background: 'linear-gradient(135deg, #EDE9FE, #E0F2FE)',
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                fontSize: '12px', fontWeight: '600', color: '#6C3AED'
                            }}>{letter}</div>
                        ))}
                        <div style={{
                            width: '32px', height: '32px', borderRadius: '50%',
                            border: '2px solid white', marginLeft: '-8px',
                            background: 'linear-gradient(135deg, #6C3AED, #0EA5E9)',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            fontSize: '11px', color: 'white'
                        }}>+</div>
                    </div>
                    <div>
                        <span style={{ color: '#FBBF24', fontSize: '14px' }}>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star-half-alt"></i>
                        </span>
                        <span style={{ marginLeft: '6px' }}>
                            {language === 'ar' ? 'موثوق من آلاف المستخدمين' : 'Trusted by thousands worldwide'}
                        </span>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default HeroSection
